import { render, staticRenderFns } from "./WaveSurferComponent.vue?vue&type=template&id=03964b72&scoped=true"
import script from "./WaveSurferComponent.vue?vue&type=script&lang=js"
export * from "./WaveSurferComponent.vue?vue&type=script&lang=js"
import style0 from "./WaveSurferComponent.vue?vue&type=style&index=0&id=03964b72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03964b72",
  null
  
)

export default component.exports